/**
 * @module store/modules/ui
 * @description UI 상태 관리 Vuex 모듈
 * 관리자 팀 유형 정보를 관리합니다.
 *
 * SURINP-191 S7 (2026-04-29, Agent Teams 5팀 병렬):
 *   - `popupSaveButton` 객체, `getPopupData` getter, `setPopupData` mutation 통째로 제거.
 *   - 모든 윈도우 팝업이 ModalPopup 기반 인-앱 모달로 흡수되면서 부모-자식 간 saveYn 통신이 emit('saved') 패턴으로 대체됨.
 *   - grep 으로 외부 사용처 0건 확인 후 dead code 정리.
 */
export default {
  // ============================================================
  // State
  // ============================================================
  state: () => ({
    adminTeamType: ''
  }),
  // ============================================================
  // Mutations
  // ============================================================
  mutations: {
    /**
     * 관리자 팀 유형을 설정합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {string} data - 관리자 팀 유형 값
     */
    adminTeamType(state, data) {
      state.adminTeamType = data
    }
  },
  // ============================================================
  // Actions
  // ============================================================
  actions: {
    /**
     * 관리자 팀 유형을 커밋합니다.
     *
     * @param {object} context - Vuex 액션 컨텍스트
     * @param {string} type - 설정할 관리자 팀 유형
     */
    setAdminTeamType({ commit }, type) {
      commit('adminTeamType', type)
    }
  }
}
